<template>
  <div class="third-box">
    <el-form ref="baseFormRef" class="goods-form" :rules="baseFormRules" :model="baseForm" label-width="128px">
      <item-box class="base-info">
        <template v-slot:title>规格配置</template>
        <template v-slot:content>
          <el-form-item label="是否开启规格" prop="openSku">
            <div class="box flex-c-s">
              <el-radio-dict :aria-hidden="true" :disabled="isReadOnly || unEditSku" dictType="YES_NO"
                v-model="baseForm.openSku" @dictChange="handleOpenSkuChange"></el-radio-dict>
              <el-tooltip effect="dark" content="注意：商品入库后，不可编辑是否开启规格！" placement="top">
                <i class="tips-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="商品规格" v-show="baseForm.openSku === '1'">
            <sku-item :isReadOnly="isReadOnly" :unEditSku="unEditSku" ref="skuItemRef" :categoryId="categoryId"
              :skuInfo="skuInfo" :format="format" @generateSkuTable="handleGenerateSkuTable"></sku-item>
          </el-form-item>
          <el-form-item label="是否开启规格图片" prop="openSkuImg" v-if="false">
            <el-radio-dict dictType="YES_NO" v-model="baseForm.openSkuImg"></el-radio-dict>
          </el-form-item>
          <el-form-item label="规格明细">
            <sku-table :goodsSn="goodsSn" :unEditSku="unEditSku" :isReadOnly="isReadOnly" ref="skuTableRef"
              :format="format" :list="spuTable" :skuList="skuList"
              :openSkuImg="baseForm.openSkuImg === '1'"></sku-table>
          </el-form-item>
        </template>
      </item-box>
      <div class="control-box flex-c-c">
        <el-button type="primary" :disabled="false" plain @click="goPre">上一步</el-button>
        <el-button type="primary" :disabled="false" @click="goNext">下一步</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import SkuItem from "./components/sku-item.vue"
import SkuTable from "./components/sku-table.vue"
export default {
  components: {
    SkuItem,
    SkuTable
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => { return {} }
    },
    isReadOnly: {
      type: Boolean,
      default: true
    },
    unEditSku: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      goodsSn: "", // 商品编号
      categoryId: "", // 商品分类id
      format: {
        skuAttrId: "skuAttrId",
        skuAttrName: "skuAttrName",
        skuValueList: "skuValueList",
        skuValue: "skuValue",
        skuValueId: "skuValueId"
      },
      baseForm: {
        openSku: "0", // 是否开启规格
        openSkuImg: "0", // 是否开启规格图片
        skuInfo: [], // 规格项数据
        spuTable: [] // 单品表
      },
      skuInfo: [],
      spuTable: [],
      baseFormRules: {
      },
      skuList: [] // 规格明细的笛卡尔积
    }
  },
  watch: {
    detailInfo: {
      handler: function(val) {
        Object.keys(this.baseForm).forEach(key => {
          if (key === "skuInfo" || key === "spuTable") {
            return
          }
          this.baseForm[key] = val[key]
        })
        this.baseForm.skuInfo = JSON.parse(val.skuInfo)
        this.baseForm.spuTable = JSON.parse(val.spuTable)
        this.skuInfo = JSON.parse(val.skuInfo)
        this.spuTable = JSON.parse(val.spuTable)
      }
    }
  },
  // created() {
  //   this.$bus.$on("skuChange", (categoryId) => {
  //     this.categoryId = categoryId
  //   })
  // },
  // beforeDestroy() { this.$bus.$off("skuChange") },
  methods: {
    setGoodsSn(goodsSn) {
      console.log("🚀 ~ setGoodsSn ~ goodsSn:", goodsSn)
      this.goodsSn = goodsSn
    },
    // 设置分类id
    setCategoryId(categoryId) {
      this.categoryId = categoryId
    },
    // 是否开启规格改变事件
    handleOpenSkuChange(val) {
      if (val === "0") {
        this.skuList = []
      } else if (val === "1") {
        this.$refs.skuItemRef.handleGenerateSkuTable()
      }
    },
    // 生成规格表
    handleGenerateSkuTable(skuInfo) {
      this.baseForm.skuInfo = skuInfo
      //获取笛卡尔积的数据列表
      const dikaerParams = skuInfo.map(item => {
        return item.skuValueList
      })
      this.skuList = this.descartes(dikaerParams)
    },
    // 生成笛卡尔积
    descartes(arr) {
      const array = arr.filter(item => {
        return item.length > 0
      })
      if (!array || !array.length) {
        return []
      }
      if (array.length === 1) {
        return array[0].map(item => {
          return [item]
        })
      }
      const result = [].reduce.call(array, function(col, set) {
        var res = []
        col.forEach(function(c) {
          set.forEach(function(s) {
            var t = [].concat(Array.isArray(c) ? c : [c])
            t.push(s)
            res.push(t)
          })
        })
        return res
      })
      return result
    },
    // 上一步
    goPre() {
      this.$emit("pre")
    },
    // 下一步
    goNext() {
      this.$refs.baseFormRef.validate(async valid => {
        if (valid) {
          let skuItemResult = true
          if (this.baseForm.openSku === "0") {
            this.baseForm.skuInfo = []
          } else if (this.baseForm.openSku === "1") {
            // 校验规格选择
            skuItemResult = await this.$refs.skuItemRef.validateSkuItem()
          }
          this.$refs.skuTableRef.getTableList().then(data => {
            if (!skuItemResult) { return }
            this.baseForm.spuTable = data
            this.$emit("next", this.baseForm)
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.third-box {
  .base-info {
    margin-top: 12px;
  }

  .goods-form {
    .el-form-item__content {

      .el-cascader,
      .el-select,
      .el-input {
        width: 360px !important;
      }

      .tips-icon {
        font-size: 24px;
        margin-left: 12px;
        line-height: 44px;
        color: $mainColor;
      }
    }
  }

}
</style>